import { message } from "antd";
// centralized toasts for future configurations
export const toast = (type, msg) => message[type](msg);
